/** biome-ignore-all lint/suspicious/noExplicitAny: auto gen.... */
type Season = {
  _id: any;
  name: string;
  eventIDs?: Array<any | null> | null;
  events: Array<{
    _id: any;
    name: string;
    tEventStart?: any | null;
  }>;
};

export const sortSeasonByEventStartTime = (a: Season, b: Season) => {
  const eventStartTimesA = a.events.map(event => event.tEventStart).map(i => new Date(i).valueOf());
  const eventStartTimesB = b.events.map(event => event.tEventStart).map(i => new Date(i).valueOf());
  return Math.min(...eventStartTimesA) - Math.min(...eventStartTimesB);
};
